(function () {
  'use strict';

  angular.module('app').component('plansPage', planListComponent());

  function planListComponent() {
    return {
      controller: PlanListCtrl,
      controllerAs: 'vm',
      bindings: {},
      templateUrl: './app/ajs/admin/plans/plans-page.component.html',
    };
  }

  PlanListCtrl.$inject = ['$location', 'PlanService'];

  function PlanListCtrl($location, PlanService) {
    var vm = this;

    // Methods
    vm.createItem = createItem;
    vm.onShowItem = onShowItem;

    // Initializers
    getItems();

    function getItems() {
      vm.loadingItems = true;

      PlanService.getPlans().then(function (data) {
        vm.items = data.items;
        vm.meta = data.meta;

        vm.loadingItems = false;
      });
    }

    function createItem() {
      $location.path('/plans/new');
    }

    function onShowItem(item, mode) {
      $location.path(`/plans/${item.id}`).search({ mode: mode });
    }
  }
})();
